import { render, staticRenderFns } from "./SearchesGroupsListPage.vue?vue&type=template&id=d2417808&scoped=true"
import script from "./SearchesGroupsListPage.vue?vue&type=script&lang=js"
export * from "./SearchesGroupsListPage.vue?vue&type=script&lang=js"
import style0 from "./SearchesGroupsListPage.vue?vue&type=style&index=0&id=d2417808&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2417808",
  null
  
)

export default component.exports